
export class TaxCodeDTO {
  id: string = '';
  hsnCode: string = '';
  total_gst: string = '';
  isDeleted: boolean = false;
  isEdit:boolean =false;
}
